import React from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Container,
} from "@mui/material";
import { keyframes } from '@emotion/react';
import card1 from "../../Assests/card1.png"
import card2 from "../../Assests/card2.png"
import card3 from "../../Assests/card3.png"
import card4 from "../../Assests/card4.png"
import card2_1 from "../../Assests/2card1.png"
import card2_2 from "../../Assests/2card2.png"
import card2_3 from "../../Assests/2card3.png"
import card2_4 from "../../Assests/2card4.png"
import business from "../../Assests/business.png"


// Example JSON Data
const cardData = [
  { title: "All-in-One Payment Powerhouse", icon: card1 },
  { title: "Simplifying Every Transaction", icon: card2 },
  { title: "Smarter Payments, Stronger Growth", icon: card3 },
  { title: "Built for Businesses, Loved by Users", icon: card4 },
  
 
];

const cardData2 = [
  { title: "Secure. Swift. Seamless.", icon: card2_1 },
  { title: "Instant Global Transactions", icon: card2_2 },
  { title: "Advanced Analytics Dashboard", icon: card2_3 },
  { title: "Multi-Currency Support", icon: card2_4 },
  
 
];

const PaymentSection = () => {
  return (
    <Box sx={{backgroundColor: "#E1EFFF"}}>
    <Box
      
      sx={{
        py: 8,
        textAlign: "center",
      }}
    >
      {/* Heading */}
      <Typography
        variant="subtitle2"
        sx={{ color: "primary.main", fontWeight: 500 , textAlign:'center' }}
      >
        Services & Solutions
      </Typography>

      <Typography
        variant="h4"
        sx={{
          mt: 1,
          fontWeight: 500,
          color: "#111827",
          lineHeight: "1"
        }}
      >
        Smart Payment Infrastructure for{" "}
        <Typography style={{   fontWeight: 500 , fontSize: "30px" , lineHeight: "1" , display:'flex', alignItems:'center', justifyContent:'center' , gap:10}}>Modern <img src={business} alt="" width={150} height={60} style={{ display: 'inline-block' , marginRight:'20px' }} /></Typography>
      </Typography>

      <Typography
        variant="body1"
        sx={{
          color: "text.secondary",
          mt: 1,
          mb: 4,
          maxWidth: 600,
          mx: "auto",
        }}
      >
        Scalable, seamless solutions, flexibility, and innovation — for the best <br />
        payment experience and growth.
      </Typography>

      {/* Animated Card Rows */}
      <Box sx={{ width: '100%', py: 2, overflow: 'hidden', position: 'relative' }}>
        {/* First Row */}
        <Box sx={{ mb: 3 }}>
          <Box
            sx={{
              display: 'flex',
              width: 'fit-content',
              animation: `${keyframes`
                0% { transform: translateX(0); }
                100% { transform: translateX(calc(-323px * ${cardData.length / 2})); }
              `} ${cardData.length * 8}s linear infinite`,
              '&:hover': {
                animationPlayState: 'paused'
              }
            }}
          >
            {[...cardData, ...cardData].map((item, index) => (
              <Box key={`row1-${index}`} sx={{ width: 300, flexShrink: 0, pr: 3, display: 'flex', alignItems: 'stretch' }}>
                <Card
                  sx={{
                    backgroundColor: "#0055FF",
                    color: "#fff",
                    borderRadius: 3,  
                    p: 2,
                    minHeight: 120,
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                    
                  }}
                >
                  <CardContent sx={{ 
                    display: "flex", 
                    alignItems: "center", 
                    p: '8px !important', 
                    width: '100%',
                    '&.MuiCardContent-root': {
                      padding: '8px !important'
                    }
                  }}>
                    <Box sx={{ flexShrink: 0, mr: 1.5 }}>
                      <img src={item.icon} alt="" width={45} height={45} />
                    </Box>
                    <Typography 
                      variant="subtitle1" 
                      sx={{ 
                        fontWeight: 500, 
                        textAlign: "left",
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        lineHeight: '1.3',
                        maxHeight: '3.2em'
                      }}
                    >
                      {item.title}
                    </Typography>
                  </CardContent>
                </Card>
              </Box>
            ))}
          </Box>
        </Box>

        {/* Second Row - Reverse Direction */}
        <Box sx={{  }}>
          <Box
            sx={{
              display: 'flex',
              width: 'fit-content',
              animation: `${keyframes`
                0% { transform: translateX(calc(-323px * ${cardData2.length / 2})); }
                100% { transform: translateX(0); }
              `} ${cardData2.length * 8}s linear infinite`,
              '&:hover': {
                animationPlayState: 'paused'
              }
            }}
          >
            {[...cardData2, ...cardData2].map((item, index) => (
              <Box key={`row2-${index}`} sx={{ width: 300, flexShrink: 0, pr: 3, display: 'flex', alignItems: 'stretch' }}>
                <Card
                  sx={{
                    backgroundColor: "#0055FF",
                    color: "#fff",
                    borderRadius: 3,
                    p: 2,
                    minHeight: 120,
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                    
                  }}
                >
                  <CardContent sx={{ 
                    display: "flex", 
                    alignItems: "center", 
                    p: '8px !important', 
                    width: '100%',
                    '&.MuiCardContent-root': {
                      padding: '8px !important'
                    }
                  }}>
                    <Box sx={{ flexShrink: 0, mr: 1.5 }}>
                      <img src={item.icon} alt="" width={45} height={45} />
                    </Box>
                    <Typography 
                      variant="subtitle1" 
                      sx={{ 
                        fontWeight: 500, 
                        textAlign: "left",
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        lineHeight: '1.3',
                        maxHeight: '3.2em'
                      }}
                    >
                      {item.title}
                    </Typography>
                  </CardContent>
                </Card>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
    </Box>
  );
};

export default PaymentSection;
